export default __webpack_public_path__ + "static/media/kaiko2.33fc22fc.png";